(function () {
    'use strict';

    angular
        .module('app.directives')
        // page title
        .directive('pageTitle', function ($rootScope, $timeout, $translate) {
            return {
                restrict: 'A',
                link: function () {
                    var listener = function (event, toState) {
                        var default_title = 'vPlaner';
                        $timeout(function () {
                            $rootScope.page_title =
                                toState.data && toState.data.pageTitle ? default_title + ' - ' + $translate.instant(toState.data.pageTitle) : $translate.instant(default_title);
                        });
                    };
                    $rootScope.$on('$stateChangeSuccess', listener);
                },
            };
        })
        // add width/height properities to Image
        .directive('addImageProp', [
            '$timeout',
            'utils',
            function ($timeout, utils) {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {
                        elem.on('load', function () {
                            $timeout(function () {
                                var w = !utils.isHighDensity() ? $(elem).width() : $(elem).width() / 2,
                                    h = !utils.isHighDensity() ? $(elem).height() : $(elem).height() / 2;
                                $(elem).attr('width', w).attr('height', h);
                            });
                        });
                    },
                };
            },
        ])
        // print page
        .directive('printPage', [
            function () {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {
                        var message = attrs['printMessage'];
                        $(elem).on('click', function (e) {
                            e.preventDefault();
                            UIkit.modal.confirm(
                                message ? message : 'Do you want to print this page?',
                                function () {
                                    // wait for dialog to fully hide
                                    setTimeout(function () {
                                        window.print();
                                    }, 300);
                                },
                                {
                                    labels: {
                                        Ok: 'print',
                                    },
                                }
                            );
                        });
                    },
                };
            },
        ])
        // full screen
        .directive('fullScreenToggle', [
            function () {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {
                        $(elem).on('click', function (e) {
                            e.preventDefault();
                            screenfull.toggle();
                        });
                    },
                };
            },
        ])
        // single card
        .directive('singleCard', [
            '$window',
            '$timeout',
            function ($window, $timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {
                        var $md_card_single = $(elem),
                            w = angular.element($window);

                        function md_card_content_height() {
                            var content_height = w.height() - (48 * 2 + 12);
                            $md_card_single.find('.md-card-content').innerHeight(content_height);
                        }

                        $timeout(function () {
                            md_card_content_height();
                        }, 100);

                        w.on('resize', function (e) {
                            // Reset timeout
                            $timeout.cancel(scope.resizingTimer);
                            // Add a timeout to not call the resizing function every pixel
                            scope.resizingTimer = $timeout(function () {
                                md_card_content_height();
                                return scope.$apply();
                            }, 280);
                        });
                    },
                };
            },
        ])
        // outside list
        .directive('listOutside', [
            '$window',
            '$timeout',
            function ($window, $timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attr) {
                        var $md_list_outside_wrapper = $(elem),
                            w = angular.element($window);

                        function md_list_outside_height() {
                            var content_height = w.height() - (48 * 2 + 10);
                            $md_list_outside_wrapper.height(content_height);
                        }

                        md_list_outside_height();

                        w.on('resize', function (e) {
                            // Reset timeout
                            $timeout.cancel(scope.resizingTimer);
                            // Add a timeout to not call the resizing function every pixel
                            scope.resizingTimer = $timeout(function () {
                                md_list_outside_height();
                                return scope.$apply();
                            }, 280);
                        });
                    },
                };
            },
        ])
        // callback on last element in ng-repeat
        .directive('onLastRepeat', function ($timeout) {
            return function (scope, element, attrs) {
                if (scope.$last) {
                    $timeout(function () {
                        scope.$emit('onLastRepeat', element, attrs);
                    });
                }
            };
        })
        // content sidebar
        .directive('contentSidebar', [
            '$rootScope',
            '$document',
            function ($rootScope, $document) {
                return {
                    restrict: 'A',
                    link: function (scope, el, attr) {
                        if (!$rootScope.header_double_height) {
                            $rootScope.$watch('hide_content_sidebar', function () {
                                if ($rootScope.hide_content_sidebar) {
                                    $('#page_content').css('max-height', $('html').height() - 40);
                                    $('html').css({
                                        paddingRight: scrollbarWidth(),
                                        overflow: 'hidden',
                                    });
                                } else {
                                    $('#page_content').css('max-height', '');
                                    $('html').css({
                                        paddingRight: '',
                                        overflow: '',
                                    });
                                }
                            });
                        }
                    },
                };
            },
        ])
        // attach events to document
        .directive('documentEvents', [
            '$rootScope',
            '$window',
            '$timeout',
            'variables',
            function ($rootScope, $window, $timeout, variables) {
                return {
                    restrict: 'A',
                    link: function (scope, el, attr) {
                        var hidePrimarySidebar = function () {
                            $rootScope.primarySidebarActive = false;
                            $rootScope.primarySidebarOpen = false;
                            $rootScope.hide_content_sidebar = false;
                            $rootScope.primarySidebarHiding = true;
                            $timeout(function () {
                                $rootScope.primarySidebarHiding = false;
                            }, 280);
                        };

                        var hideSecondarySidebar = function () {
                            $rootScope.secondarySidebarActive = false;
                        };

                        var hideMainSearch = function () {
                            var $header_main = $('#header_main');
                            $header_main.children('.header_main_search_form').velocity('transition.slideUpBigOut', {
                                duration: 280,
                                easing: variables.easing_swiftOut,
                                begin: function () {
                                    $header_main.velocity('reverse');
                                    $rootScope.mainSearchActive = false;
                                },
                                complete: function () {
                                    $header_main.children('.header_main_content').velocity('transition.slideDownBigIn', {
                                        duration: 280,
                                        easing: variables.easing_swiftOut,
                                        complete: function () {
                                            $('.header_main_search_input').blur().val('');
                                        },
                                    });
                                },
                            });
                        };

                        // hide components on $document click
                        scope.onClick = function ($event) {
                            // primary sidebar
                            if (
                                $rootScope.primarySidebarActive &&
                                !$($event.target).closest('#sidebar_main').length &&
                                !$($event.target).closest('#sSwitch_primary').length &&
                                !$rootScope.largeScreen
                            ) {
                                hidePrimarySidebar();
                            }
                            // secondary sidebar
                            if (
                                $rootScope.secondarySidebarActive &&
                                !$($event.target).closest('#sidebar_secondary').length &&
                                !$($event.target).closest('#sSwitch_secondary').length
                            ) {
                                hideSecondarySidebar();
                            }
                            // main search form
                            if (
                                $rootScope.mainSearchActive &&
                                !$($event.target).closest('.header_main_search_form').length &&
                                !$($event.target).closest('#main_search_btn').length
                            ) {
                                hideMainSearch();
                            }
                            // style switcher
                            if ($rootScope.styleSwitcherActive && !$($event.target).closest('#style_switcher').length) {
                                $rootScope.styleSwitcherActive = false;
                            }
                        };

                        // hide components on key press (esc)
                        scope.onKeyUp = function ($event) {
                            // primary sidebar
                            if ($rootScope.primarySidebarActive && !$rootScope.largeScreen && $event.keyCode == 27) {
                                hidePrimarySidebar();
                            }
                            // secondary sidebar
                            if ($rootScope.secondarySidebarActive && $event.keyCode == 27) {
                                hideSecondarySidebar();
                            }
                            // main search form
                            if ($rootScope.mainSearchActive && $event.keyCode == 27) {
                                hideMainSearch();
                            }
                            // style switcher
                            if ($rootScope.styleSwitcherActive && $event.keyCode == 27) {
                                $rootScope.styleSwitcherActive = false;
                            }
                        };
                    },
                };
            },
        ])
        // main search show
        .directive('mainSearchShow', [
            '$rootScope',
            '$window',
            '$timeout',
            function ($rootScope, $window, variables) {
                return {
                    restrict: 'E',
                    template: '<a href="#" id="main_search_btn" class="user_action_icon" ng-click="showSearch($event)"><i class="material-icons md-24 md-light">&#xE8B6;</i></a>',
                    replace: true,
                    scope: true,
                    link: function (scope, el, attr) {
                        scope.showSearch = function ($event) {
                            $event.preventDefault();

                            $('#header_main')
                                .children('.header_main_content')
                                .velocity('transition.slideUpBigOut', {
                                    duration: 280,
                                    easing: variables.easing_swiftOut,
                                    begin: function () {
                                        $rootScope.mainSearchActive = true;
                                    },
                                    complete: function () {
                                        $('#header_main')
                                            .children('.header_main_search_form')
                                            .velocity('transition.slideDownBigIn', {
                                                duration: 280,
                                                easing: variables.easing_swiftOut,
                                                complete: function () {
                                                    $('.header_main_search_input').focus();
                                                },
                                            });
                                    },
                                });
                        };
                    },
                };
            },
        ])
        // main search hide
        .directive('mainSearchHide', [
            '$rootScope',
            '$window',
            'variables',
            function ($rootScope, $window, variables) {
                return {
                    restrict: 'E',
                    template: '<i class="md-icon header_main_search_close material-icons" ng-click="hideSearch($event)">&#xE5CD;</i>',
                    replace: true,
                    scope: true,
                    link: function (scope, el, attr) {
                        scope.hideSearch = function ($event) {
                            $event.preventDefault();

                            var $header_main = $('#header_main');

                            $header_main.children('.header_main_search_form').velocity('transition.slideUpBigOut', {
                                duration: 280,
                                easing: variables.easing_swiftOut,
                                begin: function () {
                                    $header_main.velocity('reverse');
                                    $rootScope.mainSearchActive = false;
                                },
                                complete: function () {
                                    $header_main.children('.header_main_content').velocity('transition.slideDownBigIn', {
                                        duration: 280,
                                        easing: variables.easing_swiftOut,
                                        complete: function () {
                                            $('.header_main_search_input').blur().val('');
                                        },
                                    });
                                },
                            });
                        };
                    },
                };
            },
        ])

        // primary sidebar
        .directive('sidebarPrimary', [
            '$rootScope',
            '$window',
            '$timeout',
            'variables',
            function ($rootScope, $window, $timeout, variables) {
                return {
                    restrict: 'A',
                    link: function (scope, el, attr) {
                        scope.submenuToggle = function ($event) {
                            $event.preventDefault();

                            var $this = $($event.currentTarget),
                                $sidebar_main = $('#sidebar_main'),
                                slideToogle = $this.next('ul').is(':visible') ? 'slideUp' : 'slideDown';

                            $this.next('ul').velocity(slideToogle, {
                                duration: 400,
                                easing: variables.easing_swiftOut,
                                begin: function () {
                                    if (slideToogle == 'slideUp') {
                                        $(this).closest('.submenu_trigger').removeClass('act_section');
                                    } else {
                                        $(this).closest('.submenu_trigger').addClass('act_section');
                                    }
                                },
                                complete: function () {
                                    if (slideToogle !== 'slideUp') {
                                        var scrollContainer = $sidebar_main.find('.scroll-content').length
                                            ? $sidebar_main.find('.scroll-content')
                                            : $sidebar_main.find('.scrollbar-inner');
                                        $this.closest('.act_section').velocity('scroll', {
                                            duration: 500,
                                            easing: variables.easing_swiftOut,
                                            container: scrollContainer,
                                        });
                                    }
                                },
                            });
                        };
                    },
                };
            },
        ])
        // toggle primary sidebar
        .directive('sidebarPrimaryToggle', [
            '$rootScope',
            '$window',
            '$timeout',
            function ($rootScope, $window, $timeout) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: true,
                    template:
                        '<a id="sSwitch_primary" href="#" ng-click="togglePrimarySidebar($event)" ng-hide="miniSidebarActive || topMenuActive" style="line-height: 48px; float: left; margin-right: 15px;"><span class="material-icons md-color-white md-24">menu</span></a>',
                    link: function (scope, el, attrs) {
                        scope.togglePrimarySidebar = function ($event) {
                            $event.preventDefault();

                            if ($rootScope.primarySidebarActive) {
                                $rootScope.primarySidebarHiding = true;
                                if ($rootScope.largeScreen) {
                                    $timeout(function () {
                                        $rootScope.primarySidebarHiding = false;
                                        $(window).resize();
                                    }, 280);
                                }
                            } else {
                                if ($rootScope.largeScreen) {
                                    $timeout(function () {
                                        $(window).resize();
                                    });
                                }
                            }

                            $rootScope.primarySidebarActive = !$rootScope.primarySidebarActive;

                            if (!$rootScope.largeScreen) {
                                $rootScope.hide_content_sidebar = $rootScope.primarySidebarActive ? true : false;
                            }

                            if ($rootScope.primarySidebarOpen) {
                                $rootScope.primarySidebarOpen = false;
                                $rootScope.primarySidebarActive = false;
                            }
                        };
                    },
                };
            },
        ])
        // secondary sidebar
        .directive('sidebarSecondary', [
            '$rootScope',
            '$timeout',
            function ($rootScope, $timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, el, attrs) {
                        $rootScope.sidebar_secondary = true;
                        if (attrs.toggleHidden == 'large') {
                            $rootScope.secondarySidebarHiddenLarge = true;
                        }
                    },
                };
            },
        ])
        // toggle secondary sidebar
        .directive('sidebarSecondaryToggle', [
            '$rootScope',
            '$window',
            '$timeout',
            function ($rootScope, $window, $timeout) {
                return {
                    restrict: 'E',
                    replace: true,
                    template:
                        '<a href="#" id="sSwitch_secondary" class="sSwitch sSwitch_right" ng-show="sidebar_secondary" ng-click="toggleSecondarySidebar($event)"><span class="sSwitchIcon"></span></a>',
                    link: function (scope, el, attrs) {
                        scope.toggleSecondarySidebar = function ($event) {
                            $event.preventDefault();
                            $rootScope.secondarySidebarActive = !$rootScope.secondarySidebarActive;
                        };
                    },
                };
            },
        ])
        // activate card fullscreen
        .directive('cardFullscreenActivate', [
            '$rootScope',
            'variables',
            function ($rootScope, variables) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: true,
                    template: '<i class="md-icon material-icons md-card-fullscreen-activate" ng-click="cardFullscreenActivate($event)">&#xE5D0;</i>',
                    link: function (scope, el, attrs) {
                        scope.cardFullscreenActivate = function ($event) {
                            $event.preventDefault();

                            var $thisCard = $(el).closest('.md-card'),
                                mdCard_h = $thisCard.height(),
                                mdCard_w = $thisCard.width();

                            // create placeholder for card
                            $thisCard.after('<div class="md-card-placeholder" style="width:' + mdCard_w + 'px;height:' + mdCard_h + 'px;"/>');
                            // add overflow hidden to #page_content (fix for ios)
                            //$body.addClass('md-card-fullscreen-active');
                            // add width/height to card (preserve original size)
                            $thisCard
                                .addClass('md-card-fullscreen')
                                .css({
                                    width: mdCard_w,
                                    height: mdCard_h,
                                })
                                // animate card to top/left position
                                .velocity(
                                    {
                                        left: 0,
                                        top: 0,
                                    },
                                    {
                                        duration: 600,
                                        easing: variables.easing_swiftOut,
                                        begin: function (elements) {
                                            $rootScope.card_fullscreen = true;
                                            $rootScope.hide_content_sidebar = true;
                                            // add back button
                                            //$thisCard.find('.md-card-toolbar').prepend('<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left">&#xE5C4;</span>');
                                            //altair_page_content.hide_content_sidebar();
                                        },
                                    }
                                )
                                // resize card to full width/height
                                .velocity(
                                    {
                                        height: '100%',
                                        width: '100%',
                                    },
                                    {
                                        duration: 600,
                                        easing: variables.easing_swiftOut,
                                        complete: function (elements) {
                                            // activate onResize callback for some js plugins
                                            //$(window).resize();
                                            // show fullscreen content
                                            $thisCard.find('.md-card-fullscreen-content').velocity('transition.slideUpBigIn', {
                                                duration: 600,
                                                easing: variables.easing_swiftOut,
                                                complete: function (elements) {
                                                    // activate onResize callback for some js plugins
                                                    $(window).resize();
                                                },
                                            });
                                        },
                                    }
                                );
                        };
                    },
                };
            },
        ])
        // deactivate card fullscreen
        .directive('cardFullscreenDeactivate', [
            '$rootScope',
            '$window',
            'variables',
            function ($rootScope, $window, variables) {
                return {
                    restrict: 'E',
                    replace: true,
                    template:
                        '<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left" ng-show="card_fullscreen" ng-click="cardFullscreenDeactivate($event)">&#xE5C4;</span>',
                    link: function (scope, el, attrs) {
                        scope.cardFullscreenDeactivate = function ($event) {
                            $event.preventDefault();

                            // get card placeholder width/height and offset
                            var $thisPlaceholderCard = $('.md-card-placeholder'),
                                mdPlaceholderCard_h = $thisPlaceholderCard.height(),
                                mdPlaceholderCard_w = $thisPlaceholderCard.width(),
                                mdPlaceholderCard_offset_top = $thisPlaceholderCard.offset().top,
                                mdPlaceholderCard_offset_left = $thisPlaceholderCard.offset().left,
                                $thisCard = $('.md-card-fullscreen');

                            $thisCard
                                // resize card to original size
                                .velocity(
                                    {
                                        height: mdPlaceholderCard_h,
                                        width: mdPlaceholderCard_w,
                                    },
                                    {
                                        duration: 600,
                                        easing: variables.easing_swiftOut,
                                        begin: function (elements) {
                                            // hide fullscreen content
                                            $thisCard.find('.md-card-fullscreen-content').velocity('transition.slideDownOut', {
                                                duration: 280,
                                                easing: variables.easing_swiftOut,
                                            });
                                            $rootScope.card_fullscreen = false;
                                        },
                                        complete: function (elements) {
                                            $rootScope.hide_content_sidebar = false;
                                        },
                                    }
                                )
                                // move card to original position
                                .velocity(
                                    {
                                        left: mdPlaceholderCard_offset_left,
                                        top: mdPlaceholderCard_offset_top,
                                    },
                                    {
                                        duration: 600,
                                        easing: variables.easing_swiftOut,
                                        complete: function (elements) {
                                            // remove some styles added by velocity.js
                                            $thisCard.removeClass('md-card-fullscreen').css({
                                                width: '',
                                                height: '',
                                                left: '',
                                                top: '',
                                            });
                                            // remove card placeholder
                                            $thisPlaceholderCard.remove();
                                            $(window).resize();
                                        },
                                    }
                                );
                        };
                    },
                };
            },
        ])
        // card close
        .directive('cardClose', [
            'utils',
            function (utils) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: true,
                    template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardClose($event)">&#xE14C;</i>',
                    link: function (scope, el, attrs) {
                        scope.cardClose = function ($event) {
                            $event.preventDefault();

                            var $this = $(el),
                                thisCard = $this.closest('.md-card'),
                                removeCard = function () {
                                    $(thisCard).remove();
                                };

                            utils.card_show_hide(thisCard, undefined, removeCard);
                        };
                    },
                };
            },
        ])
        // card toggle
        .directive('cardToggle', [
            'variables',
            function (variables) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: true,
                    template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardToggle($event)">&#xE316;</i>',
                    link: function (scope, el, attrs) {
                        scope.cardToggle = function ($event) {
                            $event.preventDefault();

                            var $this = $(el),
                                thisCard = $this.closest('.md-card');

                            $(thisCard).toggleClass('md-card-collapsed').children('.md-card-content').slideToggle('280', variables.bez_easing_swiftOut);

                            $this.velocity(
                                {
                                    scale: 0,
                                    opacity: 0.2,
                                },
                                {
                                    duration: 280,
                                    easing: variables.easing_swiftOut,
                                    complete: function () {
                                        $(thisCard).hasClass('md-card-collapsed') ? $this.html('&#xE313;') : $this.html('&#xE316;');
                                        $this.velocity('reverse');
                                    },
                                }
                            );
                        };
                    },
                };
            },
        ])
        // card overlay toggle
        .directive('cardOverlayToggle', [
            function () {
                return {
                    restrict: 'E',
                    template: '<i class="md-icon material-icons" ng-click="toggleOverlay($event)">&#xE5D4;</i>',
                    replace: true,
                    scope: true,
                    link: function (scope, el, attrs) {
                        if (el.closest('.md-card').hasClass('md-card-overlay-active')) {
                            el.html('&#xE5CD;');
                        }

                        scope.toggleOverlay = function ($event) {
                            $event.preventDefault();

                            if (!el.closest('.md-card').hasClass('md-card-overlay-active')) {
                                el.html('&#xE5CD;').closest('.md-card').addClass('md-card-overlay-active');
                            } else {
                                el.html('&#xE5D4;').closest('.md-card').removeClass('md-card-overlay-active');
                            }
                        };
                    },
                };
            },
        ])
        // custom scrollbar
        .directive('customScrollbar', [
            '$rootScope',
            function ($rootScope) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, el, attrs) {
                        // check if mini sidebar is enabled
                        if (attrs['id'] == 'sidebar_main' && $rootScope.miniSidebarActive) {
                            return;
                        }

                        $(el).wrapInner("<div class='scrollbar-inner'></div>");
                        if (Modernizr.touch) {
                            $(el).children('.scrollbar-inner').addClass('touchscroll');
                        } else {
                            $(el).children('.scrollbar-inner').scrollbar({
                                disableBodyScroll: true,
                                scrollx: false,
                                duration: 100,
                            });
                        }
                    },
                };
            },
        ])
        // material design inputs
        .directive('mdInput', [
            '$timeout',
            function ($timeout) {
                return {
                    restrict: 'A',
                    scope: {
                        ngModel: '=',
                    },
                    controller: function ($scope, $element) {
                        var $elem = $($element);
                        $scope.updateInput = function () {
                            // clear wrapper classes
                            $elem.closest('.md-input-wrapper').removeClass('md-input-wrapper-danger md-input-wrapper-success md-input-wrapper-disabled');

                            if ($elem.hasClass('md-input-danger')) {
                                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-danger');
                            }
                            if ($elem.hasClass('md-input-success')) {
                                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-success');
                            }
                            if ($elem.prop('disabled')) {
                                $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-disabled');
                            }
                            if ($elem.val() != '') {
                                $elem.closest('.md-input-wrapper').addClass('md-input-filled');
                            }
                        };
                    },
                    link: function (scope, elem, attrs) {
                        var $elem = $(elem);

                        $timeout(function () {
                            if (!$elem.hasClass('md-input-processed')) {
                                if ($elem.prev('label').length) {
                                    $elem.prev('label').addBack().wrapAll('<div class="md-input-wrapper"/>');
                                } else if ($elem.siblings('[data-uk-form-password]').length) {
                                    $elem.siblings('[data-uk-form-password]').addBack().wrapAll('<div class="md-input-wrapper"/>');
                                } else {
                                    $elem.wrap('<div class="md-input-wrapper"/>');
                                }
                                $elem.addClass('md-input-processed').closest('.md-input-wrapper').append('<span class="md-input-bar"/>');
                            }

                            scope.updateInput();
                        });

                        /* scope.$watch(function () {
                                return elem.attr('class');
                            },
                            function (newValue, oldValue) {
                                if (newValue != oldValue) {
                                    scope.updateInput();
                                }
                            }
                        ); */

                        scope.$watch('ngModel', function (newValue, oldValue) {
                            if (newValue != oldValue) {
                                scope.updateInput();
                            }
                        });

                        $elem
                            .on('focus', function () {
                                $elem.closest('.md-input-wrapper').addClass('md-input-focus');
                            })
                            .on('blur', function () {
                                $(this).closest('.md-input-wrapper').removeClass('md-input-focus');
                                if ($(this).val() == '') {
                                    $timeout(function () {
                                        $(this).closest('.md-input-wrapper').removeClass('md-input-filled');
                                    });
                                } else {
                                    $timeout(function () {
                                        $(this).closest('.md-input-wrapper').addClass('md-input-filled');
                                    });
                                }
                            });
                    },
                };
            },
        ])
        // material design fab speed dial
        .directive('mdFabSpeedDial', [
            'variables',
            function (variables) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem, attrs) {
                        $(elem)
                            .append('<i class="material-icons md-fab-action-close" style="display:none">&#xE5CD;</i>')
                            .on('click', function (e) {
                                e.preventDefault();

                                var $this = $(this),
                                    $this_wrapper = $this.closest('.md-fab-wrapper');

                                if (!$this_wrapper.hasClass('md-fab-active')) {
                                    $this_wrapper.addClass('md-fab-active');
                                } else {
                                    $this_wrapper.removeClass('md-fab-active');
                                }

                                $this.velocity(
                                    {
                                        scale: 0,
                                    },
                                    {
                                        duration: 140,
                                        easing: variables.easing_swiftOut,
                                        complete: function () {
                                            $this.children().toggle();
                                            $this.velocity(
                                                {
                                                    scale: 1,
                                                },
                                                {
                                                    duration: 140,
                                                    easing: variables.easing_swiftOut,
                                                }
                                            );
                                        },
                                    }
                                );
                            })
                            .closest('.md-fab-wrapper')
                            .find('.md-fab-small')
                            .on('click', function () {
                                $(this).closest('.md-fab-wrapper').removeClass('md-fab-active');
                            });
                    },
                };
            },
        ])
        // material design fab toolbar
        .directive('mdFabToolbar', [
            'variables',
            '$document',
            function (variables, $document) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem, attrs) {
                        var $fab_toolbar = $(elem);

                        $fab_toolbar.children('i').on('click', function (e) {
                            e.preventDefault();

                            var toolbarItems = $fab_toolbar.children('.md-fab-toolbar-actions').children().length;

                            $fab_toolbar.addClass('md-fab-animated');

                            var FAB_padding = !$fab_toolbar.hasClass('md-fab-small') ? 16 : 24,
                                FAB_size = !$fab_toolbar.hasClass('md-fab-small') ? 64 : 44;

                            setTimeout(function () {
                                $fab_toolbar.width(toolbarItems * FAB_size + FAB_padding);
                            }, 140);

                            setTimeout(function () {
                                $fab_toolbar.addClass('md-fab-active');
                            }, 420);
                        });

                        $($document).on('click scroll', function (e) {
                            if ($fab_toolbar.hasClass('md-fab-active')) {
                                if (!$(e.target).closest($fab_toolbar).length) {
                                    $fab_toolbar.css('width', '').removeClass('md-fab-active');

                                    setTimeout(function () {
                                        $fab_toolbar.removeClass('md-fab-animated');
                                    }, 140);
                                }
                            }
                        });
                    },
                };
            },
        ])
        // material design fab sheet
        .directive('mdFabSheet', [
            'variables',
            '$document',
            function (variables, $document) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem, attrs) {
                        var $fab_sheet = $(elem);

                        $fab_sheet.children('i').on('click', function (e) {
                            e.preventDefault();

                            var sheetItems = $fab_sheet.children('.md-fab-sheet-actions').children('a').length;

                            $fab_sheet.addClass('md-fab-animated');

                            setTimeout(function () {
                                $fab_sheet.width('240px').height(sheetItems * 40 + 8);
                            }, 140);

                            setTimeout(function () {
                                $fab_sheet.addClass('md-fab-active');
                            }, 280);
                        });

                        $($document).on('click scroll', function (e) {
                            if ($fab_sheet.hasClass('md-fab-active')) {
                                if (!$(e.target).closest($fab_sheet).length) {
                                    $fab_sheet
                                        .css({
                                            height: '',
                                            width: '',
                                        })
                                        .removeClass('md-fab-active');

                                    setTimeout(function () {
                                        $fab_sheet.removeClass('md-fab-animated');
                                    }, 140);
                                }
                            }
                        });
                    },
                };
            },
        ])
        // hierarchical show
        .directive('hierarchicalShow', [
            '$timeout',
            '$rootScope',
            function ($timeout, $rootScope) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem, attrs) {
                        var parent_el = $(elem),
                            baseDelay = 60;

                        var add_animation = function (children, length) {
                            children
                                .each(function (index) {
                                    $(this).css({
                                        '-webkit-animation-delay': index * baseDelay + 'ms',
                                        'animation-delay': index * baseDelay + 'ms',
                                    });
                                })
                                .end()
                                .waypoint({
                                    element: elem[0],
                                    handler: function () {
                                        parent_el.addClass('hierarchical_show_inView');
                                        setTimeout(
                                            function () {
                                                parent_el.removeClass('hierarchical_show hierarchical_show_inView fast_animation').children().css({
                                                    '-webkit-animation-delay': '',
                                                    'animation-delay': '',
                                                });
                                            },
                                            length * baseDelay + 1200
                                        );
                                        this.destroy();
                                    },
                                    context: window,
                                    offset: '90%',
                                });
                        };

                        $rootScope.$watch('pageLoaded', function () {
                            if ($rootScope.pageLoaded) {
                                var children = parent_el.children(),
                                    children_length = children.length;

                                $timeout(function () {
                                    add_animation(children, children_length);
                                }, 560);
                            }
                        });
                    },
                };
            },
        ])
        // hierarchical slide in
        .directive('hierarchicalSlide', [
            '$timeout',
            '$rootScope',
            function ($timeout, $rootScope) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem, attrs) {
                        var $this = $(elem),
                            baseDelay = 100;

                        var add_animation = function (children, context, childrenLength) {
                            children.each(function (index) {
                                $(this).css({
                                    '-webkit-animation-delay': index * baseDelay + 'ms',
                                    'animation-delay': index * baseDelay + 'ms',
                                });
                            });
                            $this.waypoint({
                                handler: function () {
                                    $this.addClass('hierarchical_slide_inView');
                                    $timeout(
                                        function () {
                                            $this.removeClass('hierarchical_slide hierarchical_slide_inView');
                                            children.css({
                                                '-webkit-animation-delay': '',
                                                'animation-delay': '',
                                            });
                                        },
                                        childrenLength * baseDelay + 1200
                                    );
                                    this.destroy();
                                },
                                context: context[0],
                                offset: '90%',
                            });
                        };

                        $rootScope.$watch('pageLoaded', function () {
                            if ($rootScope.pageLoaded) {
                                var thisChildren = attrs['slideChildren'] ? $this.children(attrs['slideChildren']) : $this.children(),
                                    thisContext = attrs['slideContext'] ? $this.closest(attrs['slideContext']) : 'window',
                                    thisChildrenLength = thisChildren.length;

                                if (thisChildrenLength >= 1) {
                                    $timeout(function () {
                                        add_animation(thisChildren, thisContext, thisChildrenLength);
                                    }, 560);
                                }
                            }
                        });
                    },
                };
            },
        ])
        // preloaders
        .directive('mdPreloader', [
            function () {
                return {
                    restrict: 'E',
                    scope: {
                        width: '=',
                        height: '=',
                        strokeWidth: '=',
                        style: '@?',
                    },
                    template:
                        '<div class="md-preloader{{style}}"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" ng-attr-height="{{ height }}" ng-attr-width="{{ width }}" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" ng-attr-stroke-width="{{ strokeWidth }}"/></svg></div>',
                    link: function (scope, elem, attr) {
                        scope.width = scope.width ? scope.width : 48;
                        scope.height = scope.height ? scope.height : 48;
                        scope.strokeWidth = scope.strokeWidth ? scope.strokeWidth : 4;

                        attr.$observe('warning', function () {
                            scope.style = ' md-preloader-warning';
                        });

                        attr.$observe('success', function () {
                            scope.style = ' md-preloader-success';
                        });

                        attr.$observe('danger', function () {
                            scope.style = ' md-preloader-danger';
                        });
                    },
                };
            },
        ])
        .directive('preloader', [
            '$rootScope',
            'utils',
            function ($rootScope, utils) {
                return {
                    restrict: 'E',
                    scope: {
                        width: '=',
                        height: '=',
                        style: '@?',
                    },
                    template: '<img src="/img/spinners/{{style}}{{imgDensity}}.gif" alt="" ng-attr-width="{{width}}" ng-attr-height="{{height}}">',
                    link: function (scope, elem, attrs) {
                        scope.width = scope.width ? scope.width : 32;
                        scope.height = scope.height ? scope.height : 32;
                        scope.style = scope.style ? scope.style : 'spinner';
                        scope.imgDensity = utils.isHighDensity() ? '@2x' : '';

                        attrs.$observe('warning', function () {
                            scope.style = 'spinner_warning';
                        });

                        attrs.$observe('success', function () {
                            scope.style = 'spinner_success';
                        });

                        attrs.$observe('danger', function () {
                            scope.style = 'spinner_danger';
                        });

                        attrs.$observe('small', function () {
                            scope.style = 'spinner_small';
                        });

                        attrs.$observe('medium', function () {
                            scope.style = 'spinner_medium';
                        });

                        attrs.$observe('large', function () {
                            scope.style = 'spinner_large';
                        });
                    },
                };
            },
        ])
        // uikit components
        .directive('ukHtmlEditor', [
            '$timeout',
            function ($timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {
                        $timeout(function () {
                            UIkit.htmleditor(elem[0], {
                                toolbar: '',
                                height: '240',
                            });
                        });
                    },
                };
            },
        ])
        .directive('ukNotification', [
            '$window',
            function ($window) {
                return {
                    restrict: 'A',
                    scope: {
                        message: '@',
                        status: '@?',
                        timeout: '@?',
                        group: '@?',
                        position: '@?',
                        callback: '&?',
                    },
                    link: function (scope, elem, attrs) {
                        var w = angular.element($window),
                            $element = $(elem);

                        scope.showNotify = function () {
                            var thisNotify = UIkit.notify({
                                message: scope.message,
                                status: scope.status ? scope.status : '',
                                timeout: scope.timeout ? scope.timeout : 5000,
                                group: scope.group ? scope.group : '',
                                pos: scope.position ? scope.position : 'top-center',
                                onClose: function () {
                                    $('body').find('.md-fab-wrapper').css('margin-bottom', '');
                                    clearTimeout(thisNotify.timeout);

                                    if (scope.callback) {
                                        if (angular.isFunction(scope.callback())) {
                                            scope.$apply(scope.callback());
                                        } else {
                                            console.log('Callback is not a function');
                                        }
                                    }
                                },
                            });
                            if (
                                (w.width() < 768 && (scope.position == 'bottom-right' || scope.position == 'bottom-left' || scope.position == 'bottom-center')) ||
                                scope.position == 'bottom-right'
                            ) {
                                var thisNotify_height = $(thisNotify.element).outerHeight(),
                                    spacer = w.width() < 768 ? -6 : 8;
                                $('body')
                                    .find('.md-fab-wrapper')
                                    .css('margin-bottom', thisNotify_height + spacer);
                            }
                        };

                        $element.on('click', function () {
                            if ($('body').find('.uk-notify-message').length) {
                                $('body').find('.uk-notify-message').click();
                                setTimeout(function () {
                                    scope.showNotify();
                                }, 450);
                            } else {
                                scope.showNotify();
                            }
                        });
                    },
                };
            },
        ])
        // magnific popup
        .directive('magnific-popup', [
            '$timeout',
            function ($timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {},
                };
            },
        ]);
})();
